import { dew as _isValueDew } from "./is-value";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var isValue = _isValueDew();

  var forEach = Array.prototype.forEach,
      create = Object.create;

  var process = function (src, obj) {
    var key;

    for (key in src) obj[key] = src[key];
  }; // eslint-disable-next-line no-unused-vars


  exports = function (opts1
  /*, …options*/
  ) {
    var result = create(null);
    forEach.call(arguments, function (options) {
      if (!isValue(options)) return;
      process(Object(options), result);
    });
    return result;
  };

  return exports;
}